import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';

@Component({
  selector: 'app-nested-sidebar-tm400-g-wallchart',
  templateUrl: '../../templates/Template-nested-sidebar-lead.html',
  styleUrls: ['./nested-sidebar-tm400-g-wallchart.component.scss']
})
export class NestedSidebarTm400GWallchartComponent implements OnInit {

  constructor(
    public _httpService: HttpService
    ) { }

    pdf = {
      pdfTitle: '400G PAM4 High-Speed<br>Client-Side Interface Poster',
      pdfimg: './assets/images/sidebar/D99-00-011P_400G_Poster.webp',
      url: '400gposter',
      opt: 'BUTTON.DOWNLOADREQ',
      width: '800',
      height: '538'
    };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit(): void {
  }

}
